/**
 * Created by chenyj on 2019/8/5
 */

/**
 * sensors统计初始化
 */
import sensors from 'sa-sdk-javascript';
import { Tools, App } from 'youshumethod'
import {pro_name} from './env'
import config from '../../package.json'
import { envId, appid} from "./env";

export default () => {
    let server_url;
    if (envId == 1) {
        server_url ='https://sd.youshu.cc:8106/sa?project=production'
    }else {
        server_url = 'https://sd.youshu.cc:8106/sa?project=default'
    }
    sensors.init({
        server_url: server_url,
        // heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
        heatmap_url: "https://media.youshu.cc/static/js/heatmap.min.js",
        // web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
        web_url:"http://sdadmin.youshu.cc:8107",
        heatmap: {
            // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
            // 需要 JSSDK 版本号大于 1.7
            clickmap:'not_collect',
            // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
            // 需要 JSSDK 版本号大于 1.9.1
            scroll_notice_map:'not_collect',
        },
        // 两个网站是子域名关系可统一用户
        cross_subdomain: true,
        // 单页面中的页面浏览事件采集,配置参数 is_track_single_page (推荐使用这种模式)，默认值为 false ，表示是否开启自动采集 web 浏览事件 $pageview 的功能
        is_track_single_page:false,
        // 设置 true 后会在网页控制台打 logger，会显示发送的数据,设置 false 表示不显示。默认 true。
        show_log: envId == 1 ? false : true,
        // 设置为 true 表示使用客户端系统时间 false 为服务端时间
        use_client_time:false,
        // true表示采集,false表示不采集,未设置的参数取默认值
        is_track_latest: {
            // 是否采集$latest_utm最近一次广告系列相关参数，默认值true
            utm:true,
            // 是否采集$latest_traffic_source_type最近一次流量来源类型，默认值true
            traffic_source_type:true,
            // 是否采集$latest_search_keyword最近一次搜索引擎关键字，默认值true
            search_keyword:true,
            // 是否采集$latest_referrer最近一次前向地址，默认值true
            referrer:true,
            // 是否采集$latest_referrer_host最近一次前向地址，默认值true
            referrer_host:true,
            // 是否采集$latest_landing_page最近一次落地页地址，默认值false
            landing_page:false,
        },
        preset_properties: {
            //是否采集 $url 页面地址作为公共属性，默认值 false
            url: true,
            //是否采集 $title 页面标题作为公共属性，默认值 false
            title: true,
        }
    });

    // 自定义全局参数
    sensors.registerPage({
        product_name: pro_name,
        product_version : config.version,
    });

    // 用户登录
    // 先判断有auth_id,修改匿名id
    if (Tools.cookie.get('ys_wx_auth_id')) {
        sensors.identify(Tools.cookie.get('ys_wx_auth_id'), true)
    }
    // 如果user_id存在,修改匿名id
    if (Tools.cookie.get('HTTP_X_YS_UID') &&  Tools.cookie.get('HTTP_X_YS_UID') > 1) {
        sensors.login(Tools.cookie.get('HTTP_X_YS_UID'));
        let union_id = Tools.getQuery("union_id") || Tools.cookie.get('UNION_ID')
        if (union_id) {
            union_id = 'wu_' + appid +'_' + union_id
            sensors.identify(union_id, true)
            sensors.login(Tools.cookie.get('HTTP_X_YS_UID'));
        }
    }
    
    window.sensors = sensors
}
